import { z } from 'zod';

export const AccessTokenCacheDTO = z.string().optional();

export const AccessTokenLastUpdateCacheDTO = z.number().optional();
